export { default } from "./NewselaLogo";
